import { Infer, object, string } from "superstruct";
import { InjectionToken } from "tsyringe";

export const IloomCustomizationApplicationConfigSchema = object({
    wishlistPageWidgetPlaceholderSelector: string(),
    reviewsPageWidgetPlaceholderSelector: string(),
});

export type IloomCustomizationApplicationConfigInterface = Infer<
    typeof IloomCustomizationApplicationConfigSchema
>;

export const IloomCustomizationApplicationConfigToken = Symbol(
    "IloomCustomizationApplicationConfigToken"
) as InjectionToken<IloomCustomizationApplicationConfigInterface>;
